import React from 'react'
import './Part4.css'

function Part4() {
    return (
        <div className="Part4" id="contact-us">
            
            <div className="Part4-lable-container">

                <h2 className="Part4-lable">ارتباط با ما</h2>

            </div>

            <div className="Part4-contact-container">

                <a href="tel:+989373293420" className="Part4-contact-detail">

                    <div className="Part4-contact-img">

                        <img src="files/SVG/telephone.svg" alt="" className="Part4-contact-img-itself" />

                    </div>

                    <div className="Part4-contact-text-container">

                        <p className="Part4-contact-lable"> شماره تماس </p>
                
                        <p className="Part4-contact-info"> 09373293420</p>

                    </div>

                </a>

                <a href="https://instagram.com/webco.online?utm_medium=copy_link" className="Part4-contact-detail">

                    <div className="Part4-contact-img">

                        <img src="files/SVG/instagram.svg" alt="" className="Part4-contact-img-itself" />

                    </div>

                    <div className="Part4-contact-text-container">

                        <p className="Part4-contact-lable"> اینستاگرام </p>
                
                        <p className="Part4-contact-info"> webco.online</p>

                    </div>

                </a>

                <a href="https://wa.me/989373293420" className="Part4-contact-detail">

                    <div className="Part4-contact-img">

                        <img src="files/SVG/whatsapp.svg" alt="" className="Part4-contact-img-itself" />

                    </div>

                    <div className="Part4-contact-text-container">

                        <p className="Part4-contact-lable"> واتساپ </p>
                
                        <p className="Part4-contact-info"> 09373293420</p>

                    </div>

                </a>

                <a href="mailto:mehdijafarzadehh4@gmail.com" className="Part4-contact-detail">

                    <div className="Part4-contact-img">

                        <img src="files/SVG/email.svg" alt="" className="Part4-contact-img-itself" />

                    </div>

                    <div className="Part4-contact-text-container">

                        <p className="Part4-contact-lable"> ایمیل </p>
                
                        <p className="Part4-contact-info"> mehdijafarzadehh4@gmail.com</p>

                    </div>

                </a>


            </div>

        </div>
    )
}

export default Part4



// WEBPACK FOOTER //
// ./src/components/Part4/Part4.js